import { Stack, type StackProps } from "bm-ui-kit";
import React from "react";

export interface LandingHeaderLayoutProps extends StackProps {
	template: "small-calculator";
}

export const LandingHeaderLayout: React.FC<LandingHeaderLayoutProps> = (props) => {
	return (
		<Stack
			direction={{
				md: "horizontal",
			}}
			gap={{
				xs: 4,
				lg: 6,
			}}
			alignItems={{ md: "start" }}
			{...props}
		/>
	);
};
